module.exports = __webpack_public_path__ + "static/media/CT_2019_30439_8941_pdf.5dd5d8ff.pdf";